import React from "react";
import RecipientSection from "./components/RecipientSection";
import GoodsEditor from "./components/GoodsEditor";
import CertificateRemarks from "./components/CertificateRemarks";
import { Check, Field, reviewFieldId } from "./components/Fields";
import PremiumNotice from "./components/PremiumNotice";
import ReviewSection from "./components/ReviewSection";
import ReviewField from "./components/ReviewField";

export default function ReviewForm({
  draft,
  config,
  options = {},
  dictionaryChoices = [],
  dictionaryAccess,
  documents,
  onChange,
  onShowSource,
  disabled,
}) {
  const set = (field, value) => onChange({ ...draft, [field]: value });
  const fields = options.fields || [];
  const remarksKeys = new Set(options.remarksParts?.map((part) => part.key));
  return (
    <fieldset disabled={disabled}>
      <section className="card premium-panel">
        <h2>1. Eksporter</h2>
        <p style={{ whiteSpace: "pre-line" }}>{config.exporter}</p>
        <p className="small text-muted">
          Dane z ustawień firmy. Zmianę eksportera ustala administrator przed
          utworzeniem zlecenia.
        </p>
      </section>
      <ReviewSection title="2. Odbiorca">
        {(readOnly) => (
          <RecipientSection
            readOnly={readOnly}
            recipient={draft.recipient}
            candidates={draft.recipientCandidates}
            roles={options.recipientRoles}
            dictionaryChoices={dictionaryChoices}
            dictionaryAccess={dictionaryAccess}
            disabled={disabled}
            onChange={(value) => set("recipient", value)}
            onShowSource={onShowSource}
          />
        )}
      </ReviewSection>
      <ReviewSection title="3–4. Pochodzenie i transport">
        {(readOnly) => (
          <div className={readOnly ? "premium-read-grid" : undefined}>
            <ReviewField
              readOnly={readOnly}
              label="Kraj pochodzenia"
              id={reviewFieldId("countriesOfOrigin")}
              value={draft.countriesOfOrigin ?? ""}
              maxLength={2000}
              onChange={(event) => set("countriesOfOrigin", event.target.value)}
            />
            <div className={readOnly ? "premium-read-fields" : "premium-grid"}>
              {fields
                .filter((field) => !remarksKeys.has(field.key))
                .map((field) => (
                  <ReviewField
                    readOnly={readOnly}
                    key={field.key}
                    id={reviewFieldId(field.key)}
                    label={field.label}
                    value={draft[field.key]}
                    onChange={(event) => set(field.key, event.target.value)}
                  />
                ))}
            </div>
          </div>
        )}
      </ReviewSection>
      <ReviewSection title="5. Uwagi">
        {(readOnly) => (
          <CertificateRemarks
            readOnly={readOnly}
            draft={draft}
            config={config}
            options={options}
            fields={fields.filter((field) => remarksKeys.has(field.key))}
            onChange={set}
          />
        )}
      </ReviewSection>
      <ReviewSection title="6–7. Towary i ilości">
        {(readOnly) => (
          <GoodsEditor
            readOnly={readOnly}
            items={draft.items}
            grossWeight={draft.grossWeight}
            options={options}
            documents={documents}
            setItems={(value) => set("items", value)}
            onWeightChange={(value) => set("grossWeight", value)}
            onShowSource={onShowSource}
          />
        )}
      </ReviewSection>
      <section
        className="card premium-panel"
        aria-labelledby="premium-verification-title"
      >
        <h2 id="premium-verification-title">Sprawdzenie dokumentów</h2>
        {draft.sourceWarnings?.length > 0 && (
          <PremiumNotice warning>
            <strong>Uwagi odczytu (nie blokują wystawienia):</strong>
            <ul>
              {draft.sourceWarnings.map((warning, index) => (
                <li key={index}>{warning}</li>
              ))}
            </ul>
          </PremiumNotice>
        )}
        <Field
          label="Notatka z weryfikacji i korekt (opcjonalnie)"
          multiline
          value={draft.reviewNote}
          onChange={(event) => set("reviewNote", event.target.value)}
        />
        <p className="small text-muted">
          Po zapisaniu notatka pojawi się w historii zlecenia.
        </p>
        <Check
          label="Oznacz komplet dokumentów jako sprawdzony (opcjonalnie)."
          checked={draft.sourcesChecked}
          onChange={(event) => set("sourcesChecked", event.target.checked)}
        />
      </section>
    </fieldset>
  );
}
